export default __webpack_public_path__ + "static/coffe-f9e6f2c9e348d7105a797c41311c68ad.png";